import React from "react";

export const scrollWithOffset = (element: HTMLElement, offset: number): void => {
    if (offset != 0)
        window.scrollTo({ top: element.getBoundingClientRect().top + offset, behavior: 'smooth' })
    else
        setTimeout(() => element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' }), 100)
}
